<!--普通内容-->
<template>
  <div id="GeneralContent">
    <a-form-model layout="inline" :model="searchForm">
      <a-form-model-item label="内容名称">
        <a-input :maxLength="30" allowClear class="serach-item" v-model.trim="searchForm.contentName" placeholder="请输入内容名称" />
      </a-form-model-item>
      <a-form-model-item label="内容类型">
        <a-select class="serach-item" allowClear v-model="searchForm.contentType" placeholder="请选择内容类型">
          <a-select-option value="1">测评游戏</a-select-option>
          <a-select-option value="2">训练游戏</a-select-option>
          <a-select-option value="3">题目壳</a-select-option>
          <a-select-option value="4">课程视频</a-select-option>
          <a-select-option value="5">亲子游戏</a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item label="能力维度">
        <a-cascader v-model="selectId" style="width: 250px" :options="options" :load-data="loadData" placeholder="请选择能力维度" change-on-select @change="onChange" />
      </a-form-model-item>
      <a-form-model-item style="margin-right: 35px">
        <a-button @click="getPageList(1)" type="primary" html-type="button"> 查询 </a-button>
      </a-form-model-item>
      <a-form-model-item>
        <a-dropdown>
          <a-menu slot="overlay" @click="handleMenuClick">
            <a-menu-item key="1">新增到课程</a-menu-item>
            <a-menu-item key="2">新增到课时 </a-menu-item>
          </a-menu>
          <a-button type="primary" style="margin-left: 8px"> 新增 <a-icon type="down" /> </a-button>
        </a-dropdown>
      </a-form-model-item>
      <a-form-model-item>
        <a-dropdown>
          <a-menu slot="overlay" @click="handleMenuClear">
            <a-menu-item key="1">清空课程内容</a-menu-item>
            <a-menu-item key="2">清空课时内容 </a-menu-item>
          </a-menu>
          <a-button type="danger" style="margin-left: 8px"> 批量清空 <a-icon type="down" /> </a-button>
        </a-dropdown>
      </a-form-model-item>
      <a-form-model-item>
        <a-button @click="quantityVisible = true" type="primary" style="margin-left: 8px">数量管理</a-button>
      </a-form-model-item>
    </a-form-model>

    <a-table
      style="min-width: 800px"
      :columns="columns"
      :rowKey="(text, index) => text.contentId + index"
      :pagination="tableRelevant.tablePagination"
      :loading="tableRelevant.tableLoading"
      :locale="tableRelevant.locale"
      :dataSource="tableRelevant.tableDataSource"
    >
      <div slot="abilityTypeName" slot-scope="text">
        <div class="self_td" v-for="item in text.contentAbilitys" :key="item.id">
          <span v-if="text.contentType != 4">
            {{ item.abilityTypeName }}- {{ item.firstAbilityName }}-
            {{ item.secondAbilityName }}
          </span>
          <span v-else>{{ item.firstAbilityName }}</span>
        </div>
      </div>
      <div slot="action" class="action" slot-scope="text, record">
        <a @click="look(text)" href="javaScript:;">查看</a>
        <a @click="del(text)" class="red" href="javaScript:;">删除</a>
      </div>
    </a-table>

    <a-modal
      title="普通内容/新增内容"
      v-model="modal.visible"
      :confirm-loading="modal.confirmLoading"
      :cancelText="modal.cancelText"
      :okText="modal.okText"
      :centered="true"
      width="80%"
      :destroyOnClose="true"
      @ok="modelOk"
      @cancel="handleCancel"
      :cancel-button-props="{ on: { click: modelCancel } }"
    >
      <div style="padding: 0 30px">
        <a-steps :current="modal.current" style="margin-bottom: 25px">
          <a-step title="选择新内容" />
          <a-step :title="handleMenuType == 2 ? '选择课程课时' : '选择课程'" />
          <a-step title="设置内容参数" />
          <a-step title="确认新内容" />
        </a-steps>
        <FirstStep v-if="modal.current === 0" :pageData="modal.firstData" :abilityList="abilityList" ref="firstStep" />
        <template v-if="handleMenuType == 2">
          <SecondStep v-if="modal.current === 1" :pageData="modal.secondData" :contentData="modal.firstData.selectedRows" ref="secondStep" />
        </template>
        <template v-else>
          <CourseSecondStep v-if="modal.current === 1" :pageData="modal.secondData" :contentData="modal.firstData.selectedRows" ref="secondStep" />
        </template>
        <ThirdStep v-if="modal.current === 2" :contentData="modal.firstData.selectedRows" ref="thirdStep" />
        <template v-if="handleMenuType == 2">
          <FourthStep v-if="modal.current === 3" :contentData="modal.fourthData" ref="fourthStep" />
        </template>
        <template v-else>
          <CourseFourthStep v-if="modal.current === 3" :contentData="modal.fourthData" ref="fourthStep" />
        </template>
      </div>
    </a-modal>
    <!--查看内容与编辑-->
    <a-modal :title="see.title" v-model="see.visible" :destroyOnClose="true" :footer="null" :centered="true" width="80%">
      <div style="padding: 0 30px">
        <SeeContent :contentInfo="see.info" @close="seeContentClose" :abilityList="abilityList" />
      </div>
    </a-modal>
    <ClearCourseContent ref="clearCourseContentRef"></ClearCourseContent>
    <ClearChildContent ref="clearChildContentRef"></ClearChildContent>

    <quantity-manage v-model="quantityVisible"/>
  </div>
</template>

<script>
import { tableRelevant } from '@/pages/projectImpl/js/utils'
import FirstStep from './generalSteps/firstStep'
import SecondStep from './generalSteps/secondStep'
import ThirdStep from './generalSteps/thirdStep'
import FourthStep from './generalSteps/fourthStep'
import SeeContent from './components/seeContent'
import CourseSecondStep from './courseSteps/secondStep'
import CourseFourthStep from './courseSteps/fourthStep'
import ClearCourseContent from './components/clearCourseContent'
import ClearChildContent from './components/clearChildContent'
import QuantityManage from './components/quantityManage.vue'

const columns = [
  {
    title: '内容名称',
    dataIndex: 'contentName',
  },
  {
    title: '版本名称',
    dataIndex: 'versionName',
  },
  {
    title: '内容类型',
    dataIndex: 'contentTypeName',
  },
  {
    title: '能力维度',
    class: 'testClass',
    key: 'abilityTypeName',
    align: 'center',
    scopedSlots: { customRender: 'abilityTypeName' },
  },
  {
    title: '关联课程数',
    dataIndex: 'linkCourseCount',
  },
  {
    title: '关联课时数',
    dataIndex: 'linkChildCourseCount',
  },
  {
    title: '操作',
    scopedSlots: { customRender: 'action' },
  },
]
export default {
  name: 'GeneralContent',
  components: { QuantityManage, FirstStep, SecondStep, ThirdStep, FourthStep, SeeContent, CourseSecondStep, CourseFourthStep, ClearCourseContent, ClearChildContent },
  data() {
    return {
      columns,
      seriesInfo: this.$store.getters['course/getSeriesInfo'](),
      selectId: [],
      options: [],
      searchForm: {
        contentName: undefined,
        contentType: undefined,
        AbilityTypeId: undefined,
        FirstAbilityId: undefined,
        SecondAbilityId: undefined,
      },
      abilityList: [],
      //表格相关
      tableRelevant: tableRelevant.call(this),
      modal: {
        visible: false,
        confirmLoading: false,
        okText: '下一步',
        cancelText: '取消',
        current: 0,
        firstData: {
          contentType: 1,
          selectedKeys: [],
          selectedRows: [],
        },
        thirdData: {
          selectedRows: [],
        },
        secondData: {
          selectedKeys: [],
          selectedRows: [],
        },
        fourthData: [],
      },
      see: {
        visible: false,
        info: {},
      },
      handleMenuType: 1,
      // 数量管理弹出框
      quantityVisible: false
    }
  },
  mounted() {
    this.getPageList(1)
    this.abilityTypeSelect(0)
  },
  methods: {
    handleCancel() {
      this.modal.current = -1
      this.modelCancel()
    },
    async handleMenuClear({ key }) {
      if (key == 2) {
        await this.$refs['clearChildContentRef'].showModal({ type: key, seriesId: this.seriesInfo.id })
      } else {
        await this.$refs['clearCourseContentRef'].showModal({ type: key, seriesId: this.seriesInfo.id })
      }
      this.getPageList(1)
    },
    handleMenuClick({ key }) {
      this.modal.visible = true
      this.handleMenuType = key
    },
    // 能力维度
    onChange(value) {
      this.searchForm.AbilityTypeId = value[0]
      this.searchForm.FirstAbilityId = value[1]
      this.searchForm.SecondAbilityId = value[2]
      this.selectId = value
    },
    loadData(selectedOptions) {
      return new Promise((resolve, reject) => {
        const targetOption = selectedOptions[selectedOptions.length - 1]
        targetOption.loading = true
        targetOption.children = []
        let params = {
          pid: targetOption.id,
          abilityType: 0,
        }
        this.$http.abilitySelect(params).then((res) => {
            targetOption.loading = false
            targetOption.children = res.data.data.map((m) => ({
              ...m,
              value: m.id,
              label: m.name,
              isLeaf: m.levelNumber > 1,
            }))
            this.options = [...this.options]
            resolve(targetOption.children)
        })
      })
    },
    abilityTypeSelect(level) {
      let params = {
        level: level,
        abilityType: 0,
      }
      this.$http.abilitySelect(params).then((res) => {
          this.options = res.data.data
          this.options.forEach((item) => {
            item.value = item.id
            item.label = item.name
            item.isLeaf = false
          })
          if (this.searchForm.AbilityTypeId) {
            this.loadData(this.options.filter((f) => f.id === this.searchForm.AbilityTypeId)).then((data) => {
              if (this.searchForm.FirstAbilityId) {
                this.loadData(data.filter((f) => f.id === this.searchForm.FirstAbilityId))
              }
            })
          }
      })
    },
    getPageList(pageIndex) {
      for (let searchFormKey in this.searchForm) {
        if (this.searchForm[searchFormKey] === '') {
          this.searchForm[searchFormKey] = undefined
        }
      }
      const params = {
        courseSeriesId: this.seriesInfo.id,
        pageIndex: pageIndex || this.tableRelevant.tablePagination.current,
        pageSize: this.tableRelevant.tablePagination.pageSize,
        ...this.searchForm,
      }
      this.tableRelevant.tableLoading = true
      this.$http.CourseResource.serieContents(params)
        .then(({ data }) => {
          this.tableRelevant.tableDataSource = data.items
          this.tableRelevant.tablePagination.total = data.totalCount
          this.tableRelevant.tablePagination.current = data.pageIndex
        })
        .finally(() => {
          this.tableRelevant.tableLoading = false
        })
    },
    look(val) {
      this.see.title = val.versionName ? val.contentName + '-' + val.versionName : val.contentName
      this.see.info = val
      this.see.visible = true
    },
    del(val) {
      this.$confirm({
        centered: true,
        width: 500,
        okType: 'danger',
        okText: '继续删除',
        title: '批量删除内容',
        content: (h) => h('div', {}, ['此内容将从所有关联课程和关联课时中删除，请谨慎操作', h('p', { style: { color: 'red' } }, '是否继续删除?')]),
        onOk: () => {
          const params = {
            courseSeriesId: this.seriesInfo.id,
            contentId: val.contentId,
          }
          const Params = {
            "courseSeriesIds": [this.seriesInfo.id],
            "contentIds": [val.contentId]
          }
          this.tableRelevant.tableLoading = true
          this.$http.CourseResource.contentDelete(Params).then((res) => {
            this.$message.success(res.message)
            this.getPageList(1)
          }).finally(() => {
            this.tableRelevant.tableLoading = false
          })
        },
      })
    },
    seeContentClose(visible = false) {
      this.see.visible = visible
      this.getPageList(1)
    },
    modelOk() {
      this.$message.destroy()
      switch (this.modal.current) {
        case 0:
          if (!this.$refs.firstStep.$data.tableSelectedRowKeys.length) {
            this.$message.error('请选择新内容')
            return
          }
          this.modal.okText = '下一步'
          this.modal.cancelText = '上一步'
          this.modal.firstData.contentType = this.$refs.firstStep.$data.searchForm.contentType
          this.modal.firstData.selectedKeys = this.$refs.firstStep.$data.tableSelectedRowKeys
          this.modal.firstData.selectedRows = this.$refs.firstStep.$data.tableSelectedRows
          this.modal.current = 1
          break
        case 1:
          if (!this.$refs.secondStep.$data.tableSelectedRowKeys.length) {
            this.$message.error(this.handleMenuType == 2 ? '请选择课程课时' : '请选择课程')
            return
          }
          this.modal.secondData.selectedKeys = this.$refs.secondStep.$data.tableSelectedRowKeys
          this.modal.secondData.selectedRows = this.$refs.secondStep.$data.tableSelectedRows
          this.modal.current = 2
          break
        case 2:
          this.modal.firstData.selectedRows = this.$refs.thirdStep.$data.tableRelevant.tableDataSource
          const dataArr = [],
            a1 = this.modal.firstData.selectedRows,
            a2 = this.modal.secondData.selectedRows
          for (let i = 0; i < a1.length; i++) {
            for (let j = 0; j < a2.length; j++) {
              const flag = this.handleMenuType == 2 ? !(a1[i].contentType === 2 && a2[j].childCourseType === 1) : !(a1[i].contentType === 2 && a2[j].courseType === 1)
              if (flag) {
                dataArr.push({
                  ...a2[j],
                  ...a1[i],
                  contentName: a1[i].name,
                  contentId: a1[i].id,
                  courseName: a2[j].name || a2[j].courseName,
                  courseId: a2[j].id,
                  composeMode: a2[j].composeMode,
                  courseType: a2[j].courseType,
                })
              }
            }
          }
          this.modal.fourthData = dataArr
          this.modal.okText = '提交'
          this.modal.current = 3
          break
        case 3:
          const Params = {
            "courseIds": [],
            "courseSessionIds": [],
            "items": this.$refs.fourthStep.$data.tableRelevant.tableDataSource.map(m => ({
              "contentId": m.contentId,
              "executionsNumber": m.executionsNumber,
              "displayOrder": m.contentDisplayOrder,
              "isRegularContent": m.isRegularContent,
              "isLinkVedio": m.isLinkVedio,
              "contentAbilityIds": m.contentAbilitys.filter((f) => f.isSetting).map((m1) => m1.id)
            })).filter((f, i, self) => self.findIndex(t => t.contentId === f.contentId) === i)
          }
          if (this.handleMenuType == 2) {
            Params.courseSessionIds = this.$refs.fourthStep.$data.tableRelevant.tableDataSource.map(m => m.courseSessionId)
          } else {
            Params.courseIds = this.$refs.fourthStep.$data.tableRelevant.tableDataSource.map(m => m.courseId)
          }
          this.modal.confirmLoading = true
          this.$http.CourseResource.contentAdd(Params).then((res) => {
            this.$message.success(res.message)
            this.modal.visible = false
            this.getPageList(1)
            this.modal.current = 0
            this.modelCancel()
          }).finally(() => {
            this.modal.confirmLoading = false
          })
          break
      }
    },
    modelCancel() {
      switch (this.modal.current) {
        case 1:
          this.modal.cancelText = '取消'
          this.modal.current = 0
          break
        case 2:
          this.modal.okText = '下一步'
          this.modal.cancelText = '上一步'
          this.modal.current = 1
          break
        case 3:
          this.modal.current = 2
          this.modal.okText = '下一步'
          this.modal.cancelText = '上一步'
          break
        default:
          this.modal.visible = false
          this.modal.current = 0
          this.modal.firstData.contentType = 1
          this.modal.firstData.selectedKeys = []
          this.modal.firstData.selectedRows = []
          this.modal.secondData.selectedKeys = []
          this.modal.secondData.selectedRows = []
          this.modal.secondData.selectedRows = []
          this.modal.cancelText = '取消'
          this.modal.okText = '下一步'
      }
    },
  },
}
</script>

<style scoped>
#GeneralContent {
  min-height: 300px;
}

.table-ability div:not(:last-child) {
  padding-bottom: 32px;
}

/deep/ .ant-table-tbody .testClass {
  padding: 0 !important;
}

.self_td {
  height: 54px;
  display: flex;
  align-items: center;
  padding: 0 16px;
  justify-content: center;
}
</style>
